'use strict'

import { PushNotifications } from '@capacitor/push-notifications'

export default PushNotifications
